import { PageHero } from "@/components/site/PageHero";
import { Seo } from "@/components/site/Seo";
import { Reveal } from "@/components/site/Reveal";
import { BUSINESS } from "@/lib/site";

const SECTIONS = [
  {
    title: "1. What information we collect",
    body: `When you submit an enquiry or quote request, we collect the details you provide: your name, phone number, email address, property details (property type, size, number of bedrooms and bathrooms), the cleaning service you're interested in, your preferred dates and times, any notes you choose to share, and any photos of the property you choose to upload.`,
  },
  {
    title: "2. How we use your information",
    body: `We use the information you provide only to respond to your enquiry, prepare a quote, discuss your cleaning requirements, schedule services and communicate with you about your booking. We do not sell, rent or share your personal information with third parties for marketing purposes.`,
  },
  {
    title: "3. Photos you upload",
    body: `Photos you upload with your enquiry are used solely to help us understand the property and prepare an accurate quote. They are stored securely and are not published or shared.`,
  },
  {
    title: "4. Data storage and security",
    body: `Enquiry information is stored in secure systems accessible only to the business. We take reasonable steps to protect your personal information from misuse, loss and unauthorised access. Information is kept only as long as needed to manage your enquiry and any resulting services.`,
  },
  {
    title: "5. Access and correction",
    body: `You may ask us at any time to access, correct or delete the personal information we hold about you. To make a request, contact us using the details below.`,
  },
  {
    title: "6. Contact",
    body: `If you have questions about this Privacy Policy or how your information is handled, contact us at ${BUSINESS.email} or call ${BUSINESS.phone}.`,
  },
];

const Privacy = () => (
  <>
    <Seo
      title="Privacy Policy | Oz SpotNest Cleaning Service"
      description="How Oz SpotNest Cleaning Service collects, uses and protects your personal information when you request a cleaning quote or book a service."
    />
    <PageHero
      eyebrow="Legal"
      title="Privacy"
      highlight="Policy"
      description="How we collect, use and protect the information you share with us."
    />
    <section className="section-pad" data-testid="privacy-content">
      <div className="container-site max-w-3xl space-y-10">
        {SECTIONS.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.04}>
            <h2 className="text-xl font-semibold tracking-tight sm:text-2xl">{s.title}</h2>
            <p className="mt-3 text-sm leading-relaxed sm:text-base">{s.body}</p>
          </Reveal>
        ))}
        <Reveal>
          <p className="text-xs text-slate-400">Last updated: July 2026 · {BUSINESS.fullName}, {BUSINESS.address}</p>
        </Reveal>
      </div>
    </section>
  </>
);

export default Privacy;
